const rankingData = [
  { rank: 1, title: '长安十二时辰', category: '古装悬疑剧', hot: '9.8', desc: '雷佳音易烊千玺主演，唐朝反恐24小时' },
  { rank: 2, title: '流浪地球2', category: '科幻大片', hot: '9.7', desc: '吴京刘德华携手拯救人类文明' },
  { rank: 3, title: '乘风破浪的姐姐 第五季', category: '热门综艺', hot: '9.6', desc: '姐姐们再次集结舞台竞演' },
  { rank: 4, title: '庆余年 第二季', category: '古装权谋剧', hot: '9.5', desc: '张若昀回归，范闲再掀京城风云' },
  { rank: 5, title: '封神第二部', category: '奇幻史诗电影', hot: '9.4', desc: '乌尔善导演神话巨制续作' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50 mb-3">热播榜单</h2>
          <p className="text-foreground-400 text-sm">全网热播影视排行，发现大家都在看的好内容</p>
        </div>
        <div className="space-y-3 max-w-[900px] mx-auto">
          {rankingData.map((item) => (
            <div key={item.rank} className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-300/40 hover:border-primary-500/30 transition-all duration-200 group cursor-pointer">
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-black text-lg ${
                item.rank === 1 ? 'bg-accent-500 text-background-950' :
                item.rank === 2 ? 'bg-primary-500 text-background-950' :
                item.rank === 3 ? 'bg-secondary-500 text-background-950' :
                'bg-background-300 text-foreground-300'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="font-bold text-foreground-50 text-sm md:text-base group-hover:text-primary-400 transition-colors">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-background-300/60 text-foreground-400 whitespace-nowrap">{item.category}</span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-lg font-black text-primary-400">{item.hot}</div>
                <div className="text-xs text-foreground-500">热度分</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}